import { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import validator from "@rjsf/validator-ajv6";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import { Form } from "@rjsf/mui";
import { useNavigate } from "react-router-dom";
import { store } from "../../redux/store";
import DatePicker from "../form/formComponents/DatePicker";
import { worklistActions } from "../../redux/slices/worklistSlice";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme";
import UserWidget from "../users/UserWidget";
import { setBreadCrumbs } from "../../redux/slices/breadCrumbMeterSlice";
import WorklistEditorSelectorWidget from "./WorklistEditorSelectorWidget";

const ObjectFieldTemplate = (props) => {
  return (
    <Grid container alignItems="center" rowSpacing={3} spacing={2}>
      {props.properties?.map((element, i) => {
        return (
          <Grid key={element.id} alignItems="center" item xs={6}>
            {element.content}
          </Grid>
        );
      })}
    </Grid>
  );
};

const WorklistCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createdId, setCreatedId] = useState(null);
  const { t } = useTranslation();
  const [formData, setFormData] = useState();
  const [createWorklist, { isSuccess: createSuccess }] =
    store.useCreateWorkListMutation();
  const fields = {
    datepicker: DatePicker,
    users: UserWidget,
    wle: WorklistEditorSelectorWidget,
  };
  useEffect(() => {
    dispatch(worklistActions.cleanWorklist());
  }, []);
  useEffect(() => {
    dispatch(setBreadCrumbs("worklists/create"));
    return () => {
      dispatch(setBreadCrumbs(null));
    };
  }, []);
  const schema = {
    title: "New Device",
    type: "object",
    properties: {
      name: {
        $id: "8",
        type: "string",
        title: t("name"),
      },
      date: {
        $id: "3",
        title: t("inserted_at"),
        type: "object",

        properties: {
          from: {
            type: "string",
          },
          to: {
            type: "string",
          },
        },
      },
      worklisteditor: {
        $id: "1",
        type: "string",
        length: "10",
        title: t("worklisteditor"),
      },

      user_id: {
        $id: "8",
        type: "string",
        title: t("user_id"),
        requried: true,
      },
    },
    required: ["name", "worklisteditor"],
  };
  const uiSchema = {
    "ui:ObjectFieldTemplate": ObjectFieldTemplate,

    "ui:submitButtonOptions": {
      submitText: t("create"),

      props: {
        className: "bntListSearch",
        variant: window.BUTTON_TYPE,
      },
    },
    worklisteditor: {
      "ui:field": "wle",
    },
    date: {
      "ui:field": "datepicker",
    },
    user_id: {
      "ui:field": "users",
    },
  };
  useEffect(() => {
    console.log("fakd", formData);
  }, [formData]);
  const onSubmitClick = () => {
    const attributes = {
      name: formData.name,
      start_date: formData?.date?.from,
      end_date: formData?.date?.to,
      work_list_editor_id: formData?.worklisteditor,
      user_id: formData?.user_id,
    };

    createWorklist(attributes)
      .unwrap()
      .then((data) => setCreatedId(data?.data?.attributes?.id))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (createdId) {
      navigate(`/worklists/${createdId}`);
    }
  }, [createdId]);
  const customValidate = (formData, errors) => {
    if (!formData?.user_id) {
      errors?.user_id?.addError("is a required property");
    }
    if (!formData?.date?.from) {
      errors?.date?.from?.addError("is a required property");
    }
    if (!formData?.date?.to) {
      errors?.date?.to?.addError("is a required property");
    }

    return errors;
  };

  useEffect(() => {
    console.log("formdata", formData);
  }, [formData]);

  return (
    <>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {t("create_worklist")}
      </Typography>
      <Box height={200}>
        <Form
          schema={schema}
          uiSchema={uiSchema}
          fields={fields}
          formData={formData}
          validator={validator}
          onSubmit={onSubmitClick}
          onChange={(changeEvent) => setFormData(changeEvent.formData)}
          customValidate={customValidate}
          noHtml5Validate
          showErrorList={false}
        />
      </Box>
    </>
  );
};
export default WorklistCreate;
